export default function Story() {
  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center">
          {/* Image */}
          <div className="relative h-[300px] md:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/7a9a2845f004a4276c8b7a2afaa6392b.jpg"
              alt="Urban Connect Electrician at Work"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#535669] mb-4 md:mb-6">
              Our <span className="text-[#f67f19]">Story</span>
            </h2>
            <div className="space-y-4 md:space-y-6 text-gray-700 text-sm md:text-base leading-relaxed">
              <p>
                Founded over 15 years ago, Urban Connect has grown from a small local operation to become one of Sydney's most trusted names in electrical and data services. Our journey began with a simple mission: to provide honest, reliable, and professional electrical solutions to homes and businesses across Sydney.
              </p>
              <p>
                What started as a one-person operation has evolved into a team of highly skilled, licensed electricians who share our commitment to excellence. We've built our reputation on quality workmanship, transparent pricing, and exceptional customer service.
              </p>
              <p>
                Today, we're proud to serve thousands of satisfied customers across Sydney, from emergency repairs to complete electrical installations. Our lifetime guarantee on all work reflects our confidence in the quality we deliver.
              </p>
              <p className="font-bold text-[#535669]">
                Every job we complete, big or small, is backed by our commitment to safety, quality, and customer satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}